/*
 * Root component
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { RouterProvider } from 'react-router-dom';
import { ConfigContext } from '@lore/config';
import { ConnectProvider as QueryConnectProvider } from '@lore/query-connect';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import routes from './routes';
import { HelmetProvider } from 'react-helmet-async';
import { APIProvider } from '@vis.gl/react-google-maps';

App.propTypes = {
  config: PropTypes.object.isRequired,
  models: PropTypes.object.isRequired,
  collections: PropTypes.object.isRequired
};

function App(props) {
  const {
    config,
    models,
    collections
  } = props;

  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        // staleTime: Infinity,
        staleTime: 3000,
        networkMode: 'always'
      }
    }
  }));

  window.queryClient = queryClient;

  return (
    <HelmetProvider>
      <ConfigContext.Provider value={config}>
        <QueryClientProvider client={queryClient}>
          <QueryConnectProvider
            models={models}
            collections={collections}
          >
            {/*
              Single point of entry for the Google Maps JavaScript API. Libraries are
              loaded on demand by the components that need them (via useMapsLibrary),
              so no 'libraries' param is passed here.
            */}
            <APIProvider apiKey={config.google.mapApiKey}>
              <RouterProvider router={routes} />
            </APIProvider>
          </QueryConnectProvider>
        </QueryClientProvider>
      </ConfigContext.Provider>
    </HelmetProvider>
  );
}

// export default hot(module)(App);
export default App;
